import React, { useState } from 'react';

import Corner from './assets/corner.svg';
import useStyles from './styles';

interface Props {
    data: {
        title: string;
        content: React.ReactNode;
    }[];
    className?: string;
}

const Tabs: React.FC<Props> = ({ data, className }) => {
    const { classes, cx } = useStyles();
    const [active, setActive] = useState(0);

    return (
        <div className={cx(classes.root, className)}>
            <div className={classes.bar}>
                {data.map(({ title }, index) => {
                    const isActive = active === index;
                    return (
                        <div
                            key={index}
                            onClick={() => setActive(index)}
                            className={cx(classes.item, { [classes._active]: isActive })}
                        >
                            {isActive && index > 0 ? (
                                <Corner className={cx(classes.corner, classes._bottomLeft)} />
                            ) : null}
                            {title}
                            {isActive ? <Corner className={cx(classes.corner, classes._bottomRight)} /> : null}
                        </div>
                    );
                })}
            </div>
            <div className={cx(classes.content, { [classes._rounded]: active > 0 })}>{data[active].content}</div>
        </div>
    );
};

export default Tabs;
